import React from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import MessageIcon from "@mui/icons-material/Message";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import HomeIcon from '@mui/icons-material/Home';
import EventIcon from '@mui/icons-material/Event';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import {PeopleAlt} from "@mui/icons-material";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import PollIcon from '@mui/icons-material/Poll';
import BoltIcon from '@mui/icons-material/Bolt';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';

type NavigationItem = {
  text: string;
  icon: React.ReactNode;
  path: string;
  bhiAdminOnly?: boolean;
};

const sidebarItems: NavigationItem[] = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: "/home",
  },
  {
    text: "Inbox",
    icon: <QuestionAnswerIcon />,
    path: "/inbox",
  },
  {
    text: "Campaigns",
    icon: <MessageIcon />,
    path: "/campaigns",
  },
  {
    text: "Calendar",
    icon: <EventIcon />,
    path: "/calendar",
  },
  {
    text: "Asset Library",
    icon: <PermMediaIcon />,
    path: "/asset-library",
  },
  {
    text: "QR Codes",
    icon: <QrCode2Icon />,
    path: "/qr-codes",
  },
  {
    text: "Surveys",
    icon: <PollIcon />,
    path: "/surveys",
  },
  {
    text: "Link Tracking",
    icon: <InsertLinkIcon />,
    path: "/link-tracking",
  },
  {
    text: "Contacts",
    icon: <PeopleAlt />,
    path: "/groups",
  },
  {
    text: "Contact Capture",
    icon: <DynamicFormIcon />,
    path: "/contact-capture",
  },
  {
    text: "Keywords",
    icon: <TextSnippetIcon />,
    path: "/keywords",
  },
  {
    text: "Automations",
    icon: <BoltIcon />,
    path: "/automations",
    bhiAdminOnly: true,
  },
  {
    text: "Settings",
    icon: <SettingsIcon />,
    path: "/settings",
  },
];

export const getSidebarItems = (isAdmin: boolean): NavigationItem[] =>
  sidebarItems.filter(item => !item.bhiAdminOnly || isAdmin);
